var current = 'front',
    next,
    front,
    back;
    
if($('.tab-front-back div').length == 6) {
    next = 'back';
} else if($('.tab-front-back div').length == 4) {
    next = 'order';
} else {
    next = 'sleeve';
}

//show appropriate filters
function showFrontFilters() {
    $('#pattern-quality-icon-front, #pattern-quality-text-front, .filters-front').show();
    $('#pattern-quality-icon-back, #pattern-quality-text-back, .filters-back').hide();
}

function showBackFilters() {
    $('.filters-back').attr('data-pattern', '1');

    $('#pattern-quality-icon-front, #pattern-quality-text-front, .filters-front').hide();
    $('#pattern-quality-icon-back, #pattern-quality-text-back, .filters-back').show();
}

function switchFilter() {
    
    $('.flex-control-nav li:first-child, .flex-control-nav li:last-child').hide();
    $('.products-details-right').show();
    $('.product-form').hide();
    $('#product-detail').addClass('sixteen').addClass('alpha').removeClass('eight').removeClass('product-detail-box-right');
    $('.patterns li, .filters li').removeClass('active');
    $('.patterns li.' + current + ', .filters li.' + current).addClass('active');
    
    //get last active
    var active = $('.products-detai-top-nav').find('.' + current + '-last-active');
    active.addClass('active').addClass('current').siblings().removeClass('active').removeClass('current');
    var id = active.attr('for');
    
    //if sleeve
    if (current == 'sleeve') {
        disableCanvas();
        //show only patterns
        $('.nav-toolbar, .filters').hide();
        $('#'+$('.nav-toolbar:first-child').next().attr('for')).addClass('current').addClass('sleeve-height').show().siblings().hide();  
        //toggle repeat icons
        $('.repeat-to-back, .repeat-to-back-link, .scale-pattern-slider').hide();
        $('.remove-sleeve').show(); //remove sleeve icon
        canvas.allowTouchScrolling = true;
        $.unblockUI();
        return false;
    }
    $('.remove-sleeve').hide(); //remove sleeve icon
    $('#effects-toolbar').removeClass('sleeve-height');
    //show filters
    $('.nav-toolbar, .filters, .scale-pattern-slider').show();

    //filters
    (current == 'front' || $('.filters-back').attr('data-pattern') == '0' || $('.repeat-to-back').hasClass('active')) ? showFrontFilters(): showBackFilters();
    //toggle repeat icons
    (current == 'front') ? $('.repeat-to-back, .repeat-to-back-link').show(): $('.repeat-to-back, .repeat-to-back-link').hide();

    //initialize type toolbar
    $('.scale-pattern').val(parseFloat($('#'+current+'-pattern-scale').val()));
    $('#text-area').css('text-align', 'center').val(""); //clear textarea
    $('#font-size-slider').val(32);
    
    //active tab
    activeTab(id);
}

//active a perticular tab e.g. image, effect, text
function activeTab(id) {
    $.blockUI();

    canvas.allowTouchScrolling = (id == 'effects-toolbar') ? true : false;
    
    $('.tab-view-class').hide();
    $('#' + id).show();

    if (id == 'image-toolbar' || id == 'effects-toolbar') {
        selectObject('pattern');
    } else {
        $('.font-slider').slick('setPosition'); //fixed slider width 0px issue
        selectObject('i-text');
        overlayOn('text_overlay');
    } 
    
    if (current == 'front' || current == 'back') {
        var obj = canvas.getActiveObject();
        if (id == 'effects-toolbar') {
            var text_obj = getObject('i-text');
            if (text_obj) {
                canvas.sendToBack(text_obj);
            }
            canvas.sendToBack(obj);
        }
        if (obj && obj.get('id') == 'pattern' && id == 'image-toolbar') {
            var text_obj = getObject('i-text');
            if (text_obj) {
                canvas.sendToBack(text_obj);
            }
            obj.selectable = true;
            canvas.bringToFront(obj);
        }
        if (id == 'type-toolbar') {
            var p_obj = getObject('pattern');
            var dp_obj = getObject('default-pattern');
            if (obj && obj.get('id') === 'i-text') {
                obj.selectable = true;
                canvas.bringToFront(obj);
                if(obj.getSelectionStyles()) {
                    $('#font-size-slider').val(obj.getSelectionStyles().fontSize);
                } else {
                    $('#font-size-slider').val(obj.getFontSize()); 
                }
            }
            if (p_obj) {
                canvas.sendToBack(p_obj);
            }
            if (dp_obj) {
                canvas.sendToBack(dp_obj);
            }
        }
    } 
    canvas.renderAll(); 
    $.unblockUI();
}

//check repeat
function checkRepeat() {
    $('.patterns li, .filters li').removeClass('back');
    $('.patterns li.' + current + ', .filters li.' + current).addClass('back');

    selectObject('pattern');
    repeat = getActiveObject().toJSON(['objectCaching', 'id', 'selectable', 'crossOrigin', 'editable']);

    var i = 0;
    if (typeof back != "undefined" && Object.keys(back).length > 0) {
        var serialized = JSON.parse(back);
        var pattern_found = false;
        for (i, len = serialized.objects.length; i < len; i++) {
            if (serialized.objects[i] && serialized.objects[i].id === 'default-pattern') {
                serialized.objects.splice(i, 1);
            }
            if (serialized.objects[i] && serialized.objects[i].id === 'pattern') {
                serialized.objects[i] = repeat;
                serialized.objects[i].selectable = true;
                pattern_found = true;
            }
        }

        if (!pattern_found)
            serialized.objects.push(repeat);
        back = JSON.stringify(serialized);
    } else {
        back_temp = canvas.toJSON(['objectCaching', 'id', 'selectable', 'crossOrigin']);
        back_temp.overlayImage.src = origBackOverlay;
        for (i, len = back_temp.objects.length; i < len; i++) {
            if (back_temp.objects[i] && back_temp.objects[i].id === 'i-text') {
                back_temp.objects.splice(i, 1);
            }
        }
        back = JSON.stringify(back_temp);
    }
    $('#back-pattern-img').val(repeat.src);
}

//handle step navigation
function goToStep(step) {

    if (current == step || !$('.nav-toolbar.active').hasClass('current')) {
        return false;
    }

    $.blockUI();

    $('#' + step).addClass('active').siblings().removeClass('active');

    $('.nav-toolbar.active').addClass(current + '-last-active').siblings().removeClass(current + '-last-active');

    //check for repeat
    if (current == 'front' && $('.repeat-to-back').hasClass('active')) {
        checkRepeat();
    }
    
    //check step   
    if(current == 'back') {
        back = stringifyCanvas();
    }
    if(current == 'front' || current == 'sleeve') {
        front = stringifyCanvas();
    } 
    //get preview
    getPreview(current, step);
    
    //go to step 
    setTimeout(function() {
        if (step == 'front') {
            if(current == 'back' || current == 'order') {
                canvas.clear();
                try {
                    canvas.loadFromJSON(JSON.parse(front), function() {
                        canvas.renderAll().calcOffset();
                    });
                } catch (e) {
                    bugsnagClient.notify(new Error(e));
                    console.log(e);
                }
            }
            current = 'front';
            next = $('.tab-front-back div').length == 8 ? 'sleeve' : next;

        } else if (step == 'sleeve') {
            if(current == 'back' || current == 'order') {
                canvas.clear();
                try {
                    canvas.loadFromJSON(JSON.parse(front));
                } catch (e) {
                    bugsnagClient.notify(new Error(e));
                    console.log(e);
                }
            }
            canvas.deactivateAll().renderAll();

            current = 'sleeve';
            next = 'back';
        } else if (step == 'back') {
            canvas.clear();
            //if visited back ever
            if(typeof back !== 'undefined' && Object.keys(back).length > 0) {
                try {
                    canvas.loadFromJSON(JSON.parse(back), function() {
                        canvas.renderAll().calcOffset();
                    });
                } catch (e) {
                    bugsnagClient.notify(new Error(e));
                    console.log(e);
                }
            } else {    
                setOverlay(origBackOverlay); //first time only
            }

            current = 'back';
            next = 'order';
        } else {

            $.blockUI({ message: 'Please Wait...<br/>We’re Working Magic...' });

            canvas.clear();
            try {
                canvas.loadFromJSON(JSON.parse(front));
            } catch (e) {
                bugsnagClient.notify(new Error(e));
                console.log(e);
            }        

            current = 'order';
            next = 'order';
            canvas.allowTouchScrolling = true; 

            $('.products-details-right, .product-form').toggle();
            $('#product-detail').addClass('eight').addClass('product-detail-box-right').removeClass('sixteen').removeClass('alpha');
            $('.flex-control-nav li:first-child, .flex-control-nav li:last-child').show();
        }

        (current != 'order') ? setTimeout(function() {
            switchFilter();
        }, 1000): $.unblockUI();    
    }, 800);
}

$('.nav-toolbar').click(function(e) {
    //if no pattern uploaded
    if ($('.nav-toolbar.active').is("li:first-child") && !$('#image-toolbar').hasClass('current')) {
        return false;
    }

    var id = $(this).attr('for');
    $(this).addClass('active').addClass('current').siblings().removeClass('active').removeClass('current');

    activeTab(id);
});

$('.done-button').click(function(e) {
    var active, id;
    //if no pattern uploaded
    if ($('.nav-toolbar.active').is("li:first-child") && !$('#image-toolbar').hasClass('current')) {
        return false;
    }

    if (current == 'sleeve' || $('.nav-toolbar.active').is("li:last-child")) {
        goToStep($('#'+current).next('div').attr('id'));//goToStep(next);
        return false;
    }
   
    active = $('.nav-toolbar.active');
    id = active.next().attr('for');
    
    active.next().addClass('active').addClass('current').siblings().removeClass('active').removeClass('current');

    activeTab(id);
});

//read file inputs
function readFile(file) { 
    $.blockUI();   
    var file = file;
    if ( (/\.(png|jpeg|jpg|gif)$/i).test(file.name) ) {        
        var reader = new FileReader();
        reader.onload = function(f) { 
            var image = new Image();
            image.src = f.target.result;
            image.onload = function() {
                let imgSize = Math.round(file.size/(1024*1024));

                if(imgSize > 20 || (image.width*image.height) > (4500*4500)) {
                    $('#mtImgRestrict').css('display', 'block');
                } else {
                    applyPattern(f.target.result);
                }
            };
        };    
    } else {
        alert('Unsupported image extension');  
    }
    reader.readAsDataURL(file);
    $.unblockUI();
}

//initialize dropzone
var target = document.getElementById('drop-pattern');
target.addEventListener("dragover", function(e) {
    e.preventDefault();
}, true);
target.addEventListener("drop", function(e) {
    e.preventDefault();
    readFile(e.dataTransfer.files[0]);
}, true);

//click on browse
$('.browse-button-text').click(function(e) {
    $('#browse-pattern').trigger('click');
});

$('#browse-pattern').change(function(e) {
    readFile(e.target.files[0]);
});

//repeat to back
$('.repeat-to-back, .repeat-to-back-link').click(function(e) {

    if ($(this).hasClass('active') && typeof back != 'undefined' && Object.keys(back).length > 0) {
        $('#back-pattern-img').val('');
        //pattern is removed
        var serialized = JSON.parse(back);
        for (var i = 0, len = serialized.objects.length; i < len; i++) {
            if (serialized.objects[i] && serialized.objects[i].id === 'default-pattern' || serialized.objects[i] && serialized.objects[i].id === 'pattern') {
                serialized.objects.splice(i, 1);
            }
        }
        back = JSON.stringify(serialized);
    }
    $(this).toggleClass('active');
    $('.repeat-icon-img').toggle();
});

//apply image filter
$('.filters li').click(function(e) {
    $.blockUI();
    removeObject('default-pattern');
    var filterSelected = $(this).data('filter');
    if (!getObject('pattern') && $('.filters-back').attr('data-pattern') == '0' && current == 'back') {
        applyPattern($('.filters-front li:first-child').find('img').attr('src'), false, filterSelected);
        $.unblockUI();
        return false;
    }
    obj = getObject('pattern'); //get active object
    m_obj = getObject('mask');
    if (!obj.visible)
        toggleVisibility('pattern');
    obj.filters.length = 0; //remove other filters
    $('.patterns li').removeClass('active').removeClass(current);
    $(this).addClass('active').addClass(current).siblings().removeClass('active').removeClass(current);

    obj.filters[filterSelected] = imgFilters[filterSelected];
    obj.applyFilters(function(e) {
        if (m_obj) {
            canvas.bringToFront(m_obj);
        }
        canvas.sendToBack(obj).renderAll();
    });
    $.unblockUI();
});

//apply image pattern
$('.patterns li').click(function(e) {
    $.blockUI();
    var patternSelected = $(this).data('pattern');
    var patternSource = $(this).find("img").attr("src");
    var patternImage = $(this).find("img").data("src");
    $('.filters li').removeClass('active').removeClass(current);
    $(this).addClass('active').addClass(current).siblings().removeClass('active').removeClass(current);
    
    //change sleeve
    if (current == 'sleeve') {
        //load pattern image
        fabric.Image.fromURL(patternImage, function(patternImg) {
            $('#sleeve_pattern').val(patternSelected);
            $('#sleeve-pattern-img').val(patternSource); //patternImg._element.src
            //load mask image
            fabric.Image.fromURL(origSleeveOverlay1, function(maskImg) {
                //create image mask
                removeObject('mask');
                patternImg.filters.push(
                    new fabric.Image.filters.Mask({
                        'mask': maskImg,
                        'id': 'sleeve'
                    })
                );
                patternImg.applyFilters(function(img) {
                    img.id = 'mask';
                    img.selectable = false;
                    canvas.centerObject(img).add(img).renderAll();
                    img.setCoords();
                    //apply to back as well
                    var serialized = JSON.parse(stringifyCanvas());
                    var sleeve = getObject('mask').toJSON(['objectCaching', 'id', 'selectable', 'crossOrigin', 'editable']);
                    sleeve.filters[0].mask.src = origSleeveOverlay2;
                    if (typeof back === 'undefined' && Object.keys(back).length > 0) {
                        serialized.overlayImage.src = origBackOverlay;
                        serialized.objects = [];
                        serialized.objects.push(sleeve);
                        back = JSON.stringify(serialized);
                    } else {
                        var back_tmp = JSON.parse(back);
                        for (var i = 0, len = back_tmp.objects.length; i < len; i++) {
                            if (back_tmp.objects[i] && back_tmp.objects[i].id === 'mask') {
                                back_tmp.objects.splice(i, 1);
                            }
                        }
                        back_tmp.objects.push(sleeve);
                        back = JSON.stringify(back_tmp);
                    }
                    
                });
                $.unblockUI();
            }, {
                crossOrigin: 'anonymous'
            });
        }, {
            crossOrigin: 'anonymous'
        });
        return false;
    }

    p_obj = getObject('pattern');
    dp_obj = getObject('default-pattern');
    if (dp_obj) {
        removeObject('default-pattern');
    } 
    if(p_obj.visible) {
        toggleVisibility('pattern');
    }

    fabric.Image.fromURL(patternImage, function(pattern) {
        $('#' + current + '-pattern-img').val(patternSource); //patternImg._element.src
        pattern.id = 'default-pattern';
        pattern.selectable = false;
        if (mtCat.indexOf('dtg') !== -1) {        
            pattern.scaleToWidth(CORDINATES[mtCat][current].w);
            pattern.scaleToHeight(CORDINATES[mtCat][current].h);
            canvas.centerObject(pattern);
            pattern.setTop(CORDINATES[mtCat][current].t);
            canvas.add(pattern).sendToBack(pattern).renderAll();
        } else {
            pattern.scaleToWidth(canvas.getWidth());
            pattern.scaleToHeight(canvas.getHeight());
            canvas.centerObject(pattern).add(pattern).sendToBack(pattern).renderAll();
        }
        $.unblockUI();
    }, {
        crossOrigin: 'anonymous'
    });
});

//change text font
$('.font-slider div').click(function(e) {
    var obj = getObject('i-text');
    var p_obj = getObject('pattern');
    var dp_obj = getObject('default-pattern');
    if (!obj)
        return;
    $(this).addClass('active').siblings().removeClass('active');
    obj.set('fontFamily', $(this).attr('id'));
    if (dp_obj) {
        canvas.sendToBack(dp_obj);
    } else {
        canvas.sendToBack(p_obj);
    }
    obj.selectable = true;
    canvas.setActiveObject(obj).bringToFront(obj).renderAll();
});

//scale pattern
$('.scale-pattern').change(function(e) {
    var scale = $(this).val();
    $('#'+current+'-pattern-scale').val(scale);
    canvas.forEachObject(function(obj) {
        if (obj.get('id') === 'pattern' && obj.get('visible') || obj.get('id') === 'default-pattern' && obj.get('visible')) {
            //dtg
            if (mtCat.indexOf('dtg') !== -1) {
                originalScale = CORDINATES[mtCat][current].w/obj.width;
                obj.scale(originalScale*scale).center();
                obj.setTop(CORDINATES[mtCat][current].t + ((CORDINATES[mtCat][current].h - obj.getHeight())/2));
                canvas.setActiveObject(obj).renderAll();
            } else {
                originalScale = canvas.width/obj.width;
                obj.scale(originalScale*scale).center().setCoords();
            }
        }
    });
});

//remove sleeve
$('.remove-sleeve').click(function(e) {
    $('#sleeve-pattern-img').val('');
    $('#sleeve_pattern').val(0);
    $('.patterns li.active').removeClass(current).removeClass('active');
    removeObject('mask');
    canvas.renderAll();
    if(back != undefined) {
        var back_tmp = JSON.parse(back);
        for (var i = 0, len = back_tmp.objects.length; i < len; i++) {
            if (back_tmp.objects[i] && back_tmp.objects[i].id === 'mask') {
                back_tmp.objects.splice(i, 1);
            }
        }
        back = JSON.stringify(back_tmp);
    }
});

$('.flex-active').click(function(e) {
    $.blockUI();
    canvas.clear();
    canvas.setBackgroundColor('white');
    fabric.Image.fromURL($(this).attr("src"), function(preview) {
        preview.selectable = false;
        canvas.centerObject(preview).add(preview);
        canvas.getObjects()[0].top = 0;
        canvas.getObjects()[0].left = 0;
        canvas.getObjects()[0].width = canvas.width;
        canvas.getObjects()[0].height = canvas.height;
        canvas.renderAll();
        preview.setCoords();
    }, {
        crossOrigin: 'anonymous'
    });
    $.unblockUI();
});

$("#product-detail .plus").click(function(e) {
    var hidden = $('.select').find('.add-more-box:hidden').first();
    hidden.find('.variant-quantity').val(1);
    hidden.show();
    
    if ($(".add-more-box:visible").length == length) {
        $(this).hide().next('.minus').show();
        hidden.find('.plus').hide();
        hidden.find('.minus').show();
    }

});

$("#product-detail .minus").click(function(e) {
    var cur = $(this).closest('.add-more-box');
    cur.find('.variant-quantity').val(0);
    cur.hide();
    var first = $('.select').find('.add-more-box:visible').first();
    first.find('.plus').show();
    first.find('.minus').hide();
});

function overlayOn(param) {
    if(localStorage) {        
        var overlayDisplayed = localStorage.getItem(param);
        if(overlayDisplayed === null || overlayDisplayed === "true") {
            localStorage.setItem(param, false);
            document.getElementById(param).style.display = "block";
        }
    }
}

function overlayOff(param) {
    document.getElementById(param).style.display = "none";
}

$('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.add-more-box input[type=number]');

$('.add-more-box').each(function() {
    var spinner = jQuery(this),
    input = spinner.find('input[type="number"]'),
    btnUp = spinner.find('.quantity-up'),
    btnDown = spinner.find('.quantity-down'),
    min = input.attr('min'),
    max = input.attr('max');

    btnUp.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue >= max) {
        var newVal = oldValue;
    } else {
        var newVal = oldValue + 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
    });

    btnDown.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue <= min) {
        var newVal = oldValue;
    } else {
        var newVal = oldValue - 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
    });

});